import { render, staticRenderFns } from "./ContactListLog.vue?vue&type=template&id=b8572bca&"
import script from "./ContactListLog.vue?vue&type=script&lang=js&"
export * from "./ContactListLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports